export const apiServer = window.config.API_SERVER
export const baseAPIUrl = `${apiServer}/api/${window.config.API_VERSION}`
export const eventsApiServer = window.config.EVENTS_API_SERVER
export const baseEventsAPIUrl = `${eventsApiServer}/${window.config.EVENTS_API_VERSION}`
